import { InsightsCards } from "@/components/core/Insights/InsightsCards";

export default function SpotInsights() {
  return (
    <main className="container px-4 py-8">
      <InsightsCards
        title="Insights"
        subtitle="Spot-specific leaks and execution diagnostics."
        items={[
          {
            id: "leak-1",
            title: "Biggest leak",
            description: "Placeholder until insights engine is wired up.",
            value: "N/A",
            severity: "info",
          },
        ]}
      />
    </main>
  );
}
